import Introduction from "../../componets/Introduction";

export default function Section2() {
  return (
    <div className="Section2">
      <Introduction
        title="Logo and Branding That Define Your Business"
        text="Logo and branding go beyond visuals. They form the core of how people see and remember
your business. We are a branding web design agency. We create brand logos that
show your business's values, personality, and goals. Our team doesn’t just jump into visuals.
We begin by learning about your story, audience, and market position. Then, we create a
powerful visual identity using our logo and branding services."
        divider={true}
      />

      <section className="w-[90%] md:w-[80%] mx-auto flex flex-col md:flex-row items-center justify-between gap-8 py-12 px-4 bg-white">
        {/* Text Section */}
        <div className="md:w-1/2">
          <h2 className="font-bold mb-4 text-[#DA2128] leading-[normal] text-[24px] md:text-[34px]">
            Logo Design Services That Match Your Business Goals
          </h2>
          <p className="text-[#373737] font-open text-[16px] mb-6">
            Our logo design services are built around your needs. We don’t believe in using generic
            templates. We provide creative and thoughtful logo designs based on research. This helps your
            business stand out with a unique voice. Launching a new product or rebranding?
            Our process ensures your logo conveys trust and professionalism right from the start. Every
            design is created to work across all digital and print platforms.
          </p>
          <h2 className="font-bold mb-4 text-[#DA2128] leading-[normal] text-[24px] md:text-[34px]">
            More Than Just a Logo—We Build Brand Identity
          </h2>
          <p className="text-[#373737] font-open text-[16px]">
            A strong logo is just one part of a complete brand identity. That’s why we also offer full brand
            designing services to give your business a consistent and polished presence. Your brand
            colors, fonts, visual styles, and guidelines all match your marketing goals. Our team focuses on
            making every design element enhance a trustworthy brand. This is vital when people are
            deciding on matters that affect their lives or money.
          </p>
        </div>

        {/* Image Section */}
        <div className="md:w-1/2">
          <img
            src="../../../../assets/brand.png"
            alt="Logo Design"
            className="w-full h-auto rounded-xl shadow-md"
          />
        </div>
      </section>
    </div>
  );
}
